import { render, staticRenderFns } from "./TransactionsManage.vue?vue&type=template&id=b75fd738"
import script from "./TransactionsManage.vue?vue&type=script&lang=js"
export * from "./TransactionsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports